module.exports = __webpack_public_path__ + "account.svg?fea5f46513b3bacdf1f54ea71dc49d41";